export default "__VITE_ASSET__CBQyGcuZ__"